import type { PropsWithChildren } from "react";
import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import { Dialog, DialogContent, Loading } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./PageLoadingScreen.module.scss";

// Import images to ensure they're processed by the bundler
import logo from "@/assets/images/logo.png";
import blueFigure from "@/assets/loading-screen/blue-figure.svg";
import bottomRounded from "@/assets/loading-screen/bottom-rounded.webp";
import orangeFigure from "@/assets/loading-screen/orange-figure.svg";
import redFigure from "@/assets/loading-screen/red-figure.svg";
import topRightCorner from "@/assets/loading-screen/top-right-corner.webp";

export interface PageLoadingScreenComponentProps {
  className: string;
  isLoading?: boolean;
  backgroundImage?: string;
  text?: string;
}
export const PageLoadingScreen = ({
  isLoading = false,
  className,
  text = "",
}: PropsWithChildren<PageLoadingScreenComponentProps>) => {
  const styles = useUiStyles(CoreUiComponents.PageLoadingScreen, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.PageLoadingScreen);

  return (
    <Dialog open={isLoading}>
      <DialogContent
        className={cn("dialog-root")}
        showCloseButton={false}
        header={<></>}
      >
        <div className={cn("content")}>
          <div className={clsx(cn("image"), cn("image-top-right"))}>
            <img src={topRightCorner} alt="people in car" />
          </div>
          <div className={clsx(cn("shape"), cn("shape-blue"))}>
            <img src={blueFigure} alt="blue figure" />
          </div>
          <div className={clsx(cn("shape"), cn("shape-orange"))}>
            <img src={orangeFigure} alt="orange figure" />
          </div>
          <div className={clsx(cn("image"), cn("image-bottom-rounded"))}>
            <img src={bottomRounded} alt="kayaking" />
          </div>
          <div className={clsx(cn("shape"), cn("shape-red"))}>
            <img src={redFigure} alt="red figure" />
          </div>
          <div className={clsx(cn("shape"), cn("logo"))}>
            <img src={logo} alt="logo" />
          </div>

          <div className={cn("content-inner")}>
            <div className={cn("icon")}>
              <Loading />
            </div>
            {text && <div className={cn("text")}>{text}</div>}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
